export  enum UserRole {
  USER = 1,
  ADMIN = 2,
  SYS_ADMIN = 3,
  MANAGER = 4,
}

// 1 - users
// 2 - admin
// 3 - sys-admin
// 4 - manager 